module.exports = __webpack_public_path__ + "img/va.8e67e877.svg";